import {useSelector} from 'react-redux'
import {getUserData} from '../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'

export const Admin_Staff = ['superAdmin', 'staffAdmin', 'sales', 'accountManager', 'support']

export const Auth = () => {
  const Role = useSelector(getUserData)
  if (Admin_Staff?.includes(Role)) {
    return true
  } else {
    return false
  }
}

export const AuthPermission = (path: any) => {
  const UserRole = useSelector(getUserData)

  const AdminRole = useSelector((state: any) => state?.AdminAuth?.adminData?.data?.user?.role)

  if (UserRole?.includes(path) || AdminRole?.includes(path)) {
    return true
  } else {
    return false
  }
}
export const GeneralDataOFLoginUser = () => {
  const UserRole = useSelector(getUserData)
  const AdminRole = useSelector((state: any) => state?.AdminAuth?.adminData?.data?.user)

  if (Object.keys(UserRole)?.length > 0) {
    return UserRole
  } else {
    return AdminRole
  }
}

export const LoginRole = () => {
  const UserRole = useSelector(getUserData)
  const AdminRole = useSelector((state: any) => state?.AdminAuth?.adminData?.data?.user?.role)

  if (UserRole !== undefined) {
    return UserRole
  } else {
    return AdminRole
  }
}
